module.exports = __webpack_public_path__ + "img/Logo_Pilsa_Blanco_Inferior.559b5ef5.webp";